import { createGlobalStyle } from 'styled-components';

export const devices = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '800px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

export const GlobalStyles = createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    outline:0;
    box-sizing: border-box;
  }

  *::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  *::-webkit-scrollbar-track {
    background: none;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #CCCCCC;
    border-radius: 20px;
    border: 3px solid #CCCCCC;
  }

  html {
    --font-size-xs: 1.1rem;
    --font-size-sm: 1.2rem;
    --font-size-md: 1.35rem;
    --font-size-lg: 1.6rem;
    --font-size-xl: 2rem;
    --font-size-2xl: 2.4rem;

    --space-1: 4px;
    --space-2: 8px;
    --space-3: 12px;
    --space-4: 16px;
    --space-5: 20px;
    --space-6: 24px;
    --space-7: 28px;

    --radius-sm: 6px;
    --radius-md: 8px;
    --radius-lg: 12px;
    --radius-xl: 16px;

    --shadow-sm: 0 1px 3px rgba(15, 23, 42, 0.06);
    --shadow-md: 0 6px 18px rgba(15, 23, 42, 0.08);
    --shadow-lg: 0 14px 34px rgba(15, 23, 42, 0.12);

    --app-topbar-height: 60px;
    --app-sidebar-open-width: 240px;
    --app-sidebar-collapsed-width: 64px;
    --app-shell-padding: 18px;
    --app-page-padding-block: 18px;
    --app-page-padding-inline: 22px;
    --app-hero-padding-block: 22px;
    --app-hero-padding-inline: 24px;
    --app-topbar-padding-inline: 18px;
    --app-topbar-gap: 16px;
    --app-search-max-width: 420px;
    --app-control-min-height: 40px;

    /* Cockpit de pesagem: um só tamanho para todo campo de preencher, e uma só
     * altura para toda linha de leitura. O peso é a única exceção proposital —
     * é o único elemento grande da tela. Ver PLANO_REESTRUTURACAO_COCKPIT §2.2 R5/R6. */
    --cockpit-control-h: 40px;
    --cockpit-weight-h: 72px;
    --field-row-h: 28px;
    --field-row-h-compact: 24px;

    --app-card-padding: 16px;
    --app-card-radius: var(--radius-lg);
    --app-container-max-width: 1680px;
    font-size: 62.5%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  body {
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 14px;
    font-family: 'Nunito', sans-serif;
    background-color: #F8F8F9;
    min-height: 100vh;
    overflow-wrap: break-word;
    word-break: normal;
  }

  body, input, textarea, button, select, span {
    font-family: 'Nunito', sans-serif;
  }

  #root {
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
  }

  img,
  svg:not([data-icon]) {
    max-width: 100%;
    height: auto;
  }

  table {
    min-width: 0;
  }

  input,
  select,
  textarea {
    max-width: 100%;
    min-width: 0;
  }

  .swal2-container {
    padding: var(--space-5) !important;
  }

  .swal2-popup.cf-swal-popup {
    width: min(100%, 480px) !important;
    border-radius: var(--radius-xl) !important;
    border: 1px solid rgba(45, 106, 79, 0.12) !important;
    padding: 22px 22px 20px !important;
    background: linear-gradient(180deg, #ffffff 0%, #fbfcfb 100%) !important;
    box-shadow: var(--shadow-lg) !important;
  }

  .swal2-title.cf-swal-title {
    margin: 6px 0 10px !important;
    color: #1f2937 !important;
    font-size: 2.4rem !important;
    font-weight: 800 !important;
    line-height: 1.15 !important;
  }

  .swal2-html-container.cf-swal-html {
    margin: 0 auto !important;
    max-width: 420px;
    color: #5f6b63 !important;
    font-size: 1.4rem !important;
    line-height: 1.55 !important;
  }

  .swal2-actions.cf-swal-actions {
    margin-top: 22px !important;
    gap: 10px !important;
  }

  .swal2-popup.cf-swal-popup .swal2-styled {
    min-width: 120px;
    border: 0 !important;
    border-radius: var(--radius-md) !important;
    padding: 9px 16px !important;
    font-size: 1.32rem !important;
    font-weight: 800 !important;
    box-shadow: none !important;
  }

  .swal2-popup.cf-swal-popup .swal2-styled:focus {
    box-shadow: 0 0 0 4px rgba(45, 106, 79, 0.18) !important;
  }

  .swal2-popup.cf-swal-popup .swal2-cancel {
    color: #ffffff !important;
  }

  .swal2-icon.cf-swal-icon {
    margin: 4px auto 10px !important;
  }

  .swal2-icon.swal2-question.cf-swal-icon,
  .swal2-icon.swal2-warning.cf-swal-icon,
  .swal2-icon.swal2-info.cf-swal-icon {
    width: 60px !important;
    height: 60px !important;
    border-width: 3px !important;
  }

  .swal2-icon.swal2-question.cf-swal-icon {
    border-color: #8fb6cc !important;
    color: #7ea7bf !important;
  }

  .swal2-icon.swal2-warning.cf-swal-icon {
    border-color: #f59e0b !important;
    color: #d97706 !important;
  }

  .swal2-icon.swal2-info.cf-swal-icon {
    border-color: #60a5fa !important;
    color: #3b82f6 !important;
  }

  .swal2-icon.cf-swal-icon .swal2-icon-content {
    font-size: 3.6rem !important;
    font-weight: 700 !important;
  }

  @media (max-width: 425px) {
    html {
      font-size: 58%;
      --app-control-min-height: 36px;
    }
  }

  /* No curral o campo é tocado com a mão suja e às vezes com luva: 44px é o
   * piso de alvo tocável. Ainda assim é menor que os 46–52px que o cockpit
   * usava antes — o pedido de "campo mais fino" continua atendido. */
  @media (pointer: coarse) {
    html {
      --cockpit-control-h: 44px;
      --cockpit-weight-h: 84px;
      --field-row-h: 32px;
      --field-row-h-compact: 28px;
    }
  }

  button,
  a,
  [role='button'] {
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }

  @media (max-width: 1024px) {
    table {
      display: block;
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
    }
  }

  @media (max-width: 425px) {
    .swal2-popup.cf-swal-popup {
      padding: 20px 16px 18px !important;
      border-radius: 18px !important;
    }

    .swal2-title.cf-swal-title {
      font-size: 2.2rem !important;
    }

    .swal2-html-container.cf-swal-html {
      font-size: 1.35rem !important;
    }

    .swal2-actions.cf-swal-actions {
      flex-direction: column !important;
      gap: 8px !important;
    }

    .swal2-popup.cf-swal-popup .swal2-styled {
      width: 100% !important;
      min-width: 0 !important;
    }
  }
`;
